import { render, staticRenderFns } from "./MarketWrapper.vue?vue&type=template&id=da0d8704&scoped=true&"
import script from "./MarketWrapper.vue?vue&type=script&lang=js&"
export * from "./MarketWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0d8704",
  null
  
)

export default component.exports